import React from 'react';
import styled, { css } from 'react-emotion';

const Section = styled.section`
  margin: 44px 0;
`;

const Teaser = () => (
  <Section>
    <p
      className={css`
        font-size: 1.2em;
        text-align: center;
        font-family: monospace;
        max-width: 590px;
        margin: auto;
      `}
    >
      This page is in a somewhat bad state! But for a good reason, it undergoes a relaunch. I know
      what you think: <b>&raquo;I&apos;ve heard that one before.&laquo;</b> But why not get notified
      when it happens?
    </p>
    <p
      className={css`
        text-align: center;
        margin: 24px 0 0;
      `}
    >
      <a
        href="http://eepurl.com/ceBsaD"
        className={css`
          display: inline-block;
          padding: 4px 18px;
          background: red;
          color: ghostwhite;
          border: 2px solid ghostwhite;
          text-decoration: none;
        `}
      >
        Newsletter
      </a>
    </p>
  </Section>
);

export default Teaser;



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/NewsletterBox/NewsletterBox.jsx